import {
  add,
  check,
  circle,
  close,
  spinner,
  star,
  trash,
  fastForward,
  rewind,
} from './icons/application'
import { arrowDown, arrowUp, down, right, left } from './icons/directional'
import { date, color } from './icons/input'
import { fileDoc } from './icons/file'

/**
 * The collection of icons required by the Genesis theme.
 *
 * @public
 */
const genesisIcons = {
  add,
  arrowDown,
  arrowUp,
  check,
  close,
  checkboxDecorator: check,
  date,
  fileItem: fileDoc,
  fileRemove: close,
  noFiles: fileDoc,
  radioDecorator: circle,
  select: down,
  spinner,
  star,
  trash,
  fastForward,
  right,
  left,
  rewind,
  color,
}

export default genesisIcons
